import React from 'react';
import { Users, Shield, PoundSterling, BadgeCheck } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  Users: Users,
  Shield: Shield,
  PoundSterling: PoundSterling,
  BadgeCheck: BadgeCheck
};

const WhyChooseUs = () => {
  return (
    <section id="why-us" className="py-24 bg-[#0f1729] relative overflow-hidden">
      {/* Decorative gradient blurs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#3B43AF]/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-[#3B43AF]/10 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-br from-[#3B43AF]/5 to-transparent rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-[#3B43AF]/20 text-[#7C83E0] font-semibold text-sm rounded-full mb-6 tracking-wide">Why Us</span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white mb-6">Why Choose HappyVan</h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed">
            We're not just movers – we're your partners in making your move stress-free and successful.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="group text-center"
                data-testid={`why-us-feature-${feature.id}`}
              >
                {/* Icon */}
                <div className="w-20 h-20 bg-[#3B43AF]/20 group-hover:bg-[#3B43AF] rounded-2xl flex items-center justify-center mx-auto mb-6 transition-all duration-500 group-hover:shadow-xl group-hover:shadow-[#3B43AF]/30 group-hover:-translate-y-2 backdrop-blur-sm border border-[#3B43AF]/30">
                  <IconComponent className="w-10 h-10 text-[#7C83E0] group-hover:text-white transition-colors duration-500" />
                </div>

                {/* Content */}
                <h3 className="font-heading text-xl font-bold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 pt-12 border-t border-white/10">
          {[
            { number: '10+', label: 'Years Experience' },
            { number: '500+', label: 'Happy Customers' },
            { number: '1000+', label: 'Moves Completed' },
            { number: '5★', label: 'Google Rating' }
          ].map((stat, index) => (
            <div key={index} className="text-center group" data-testid={`why-us-stat-${index}`}>
              <p className="font-heading text-4xl md:text-5xl font-bold text-white mb-2">{stat.number}</p>
              <p className="text-gray-400">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
